/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
//const TEST = `https://d11-api-backend-java-test-dt.io.mlj130.com`;
const TEST = `https://component-activity-backend-go-test-dt.io.mlj162.com/`; // http://192.168.3.4:9099/
const PRODUCTION = `https://component-activity-backend-go.io.mlj162.com/`;
const DOMAIN = process.env.PREACT_APP_ENV === "development" ? PRODUCTION : PRODUCTION;
export  {DOMAIN};
